// extracted by mini-css-extract-plugin
module.exports = {"details_share":"DetailsShare_details_share__KSZIV","shareBTN":"DetailsShare_shareBTN__1ILU3"};